import {ref, unRef, shallowRef, computed, onMounted} from 'vue'
import {_get} from '@/actions.js'
import {make_headPhotos} from './photos.js'

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)
dayjs.extend(customParseFormat)



const DPPROV = {
    48: 'inf',
    49: 'vdh',
}
export const isVdh = (dp_id) => 49 === dp_id
export const isInf = (dp_id) => 48 === dp_id
const prov_sid = (dp_id) => {
    let r = DPPROV[ dp_id ]
    if (!r) {
        r = `dp_id=${dp_id}`
    }
    return r
}

const diffH = (now, mtime) => {
    let date1 = dayjs( now )
    let h = date1.diff( mtime, 'hour' )
    let ret = h > 0 ? `${h}ч. назад` : `меньше часа назад`
    return ret
}

/********************************************
*  дергаем при загрузке круиза, 
*  чтобы установить ages и убрать занятые Rooms
*  установить max_cabins
*/
export const getCruiseRoomsAges = ( { // дергаем при загрузке круиза и передаем все в bookCabins.initBookBox
        cruiseFull: { ages },
        cruiseHead: { offer_id, max_cabins },
        roomDetail: { rooms },
} ) => {
        const cruiseIdFull = offer_id.toString()
        const m = rooms.filter( r => r.availability ).map( ({id, acc})=>{
            return [id, {id, acc}]
        } )
        const roomsMap = Object.fromEntries(m)
        if (!max_cabins) {
            max_cabins = 1
        }

        return {ages, cruiseIdFull, roomsMap, max_cabins}
}

export const getRoomsMap = ( { roomDetail: { rooms} } ) => {
    const m=rooms.map( ({id, acc, availability})=>{
        return [id, {id, acc, availability}]
    } )
    const ret = Object.fromEntries(m)
    return m
}

const get_shipServices = aXo => {// на выходе массив, возможно пустой
    let ret
    if (Array.isArray(aXo)) {
        ret = aXo
    } else if (aXo && 'object' === typeof(aXo)) {
        ret = Object.values(aXo)
    } else {
        ret = []
    }
    return ret
}

export default function useCruise({cruiseHead, cruiseFull}) {

    let {
        offer_id, is_sea, cruise_id, dp_id,  ship_id,
        swtown_id, bwtown_id, stown_id, btown_id,
        name, nights, days,
        date, dateStart, dateEnd, is_cruise_time_published,
        route,
        photo,
        cruise_photos,
        prices, freeRooms, isKlk,
        ship, mtime,
    } = cruiseHead

    const now = new Date;

    const cruiseIdFull = offer_id.toString()
    const cruiseId = cruise_id.toString()
    const prov = prov_sid( dp_id )
    const cruiseIdString = `Круиз № ${offer_id} / ${cruise_id} ${prov}`

    const shipId = ship_id.toString()
    const shipName = ship.name
    const shipStar = ship.star || ''
    const shipCompany = ship.company || ''
    const shipServices = get_shipServices(ship.services)
    nights  = parseInt( nights, 10 )
    days = parseInt( days, 10 )
    const beautifulName = name
    const min_price = { ...prices, is: prices.v[0] ? true : false }
    const photoMain = photo
    const freeCabins = freeRooms
    const dateStartOb = dayjs( dateStart ).locale('ru')
    const dateEndOb = dayjs( dateEnd ).locale('ru')
    const checkedH = diffH( now, mtime)

    const headPhotos = make_headPhotos( cruise_photos, photo, {makeUniq:true} )

    const cruise_link = { 
        name: 'Cruise', 
        query: {
            cruiseIdFull,
        }
    }
    const cruise_tt_link = { 
        name: 'CruiseTimetable', 
        query: {
            cruiseIdFull,
        }
    }
    const ship_link = {
        name: 'Ship', 
        query: {
            id: shipId
        }
    }

    const shipHead = {
        id: ship.id,
        name: shipName,
        company: shipCompany,
        is_sea: ship.is_sea,
        services: shipServices,
        link: ship_link,
        star: shipStar,
    }

    const dates = {
        dateStartOb, dateEndOb, days, is_cruise_time_published
    }


    let {
        routeFull, photos,
        discounts, discount, 
//        included, excluded, description, restaurants,
        dataInf,  
    } = cruiseFull || {}

    const htmlblock = (ob, name, dop ) => {
        let html = ob && ob[name] ? ob[name] : ''
        let has = html ? true : false
        let link = dop.link ??  'all' // all pdf none - какие ссылки оставлять
        let orig = dop.orig ?? false // orig - не менять, для отладки
        let ret = {
            has,
            html,
            link,
            orig,
        }
        return ret
    }

    const included = htmlblock( cruiseFull, 'included', {link: 'pdf'} )
    const excluded = htmlblock( cruiseFull, 'excluded', {link: 'pdf'} )
    const description = htmlblock( cruiseFull, 'description', {link: 'pdf'} )
    const restaurants = htmlblock( cruiseFull, 'restaurants', {link: 'pdf'} )

    const timetable_inf_func =  ttin => {
        let ttin_max_ind = ttin.length - 1
        let { group, } = ttin.reduce( ( { group, first }, stop, ind)=> {
            const start = dayjs(stop.dateArrival, 'YYYY-MM-DD') // без времени
            let day // номер дня 1 ...
            let hasArrival =  ind !== 0 // имеет смысл дата прибытия теплохода
            let hasDeparture = ind !== ttin_max_ind // имеет смысл дата отправления теплохода
            if (!first) {
                first = start
                day = 1
            } else {
                day = 1 + dayjs.duration(start.diff(first)).asDays()
            }
            let daystops, dayrec
            if (!group.has(day)) {
                daystops = []
                dayrec = { start, nday:day  }
            } else {
                let g = group.get(day)
                daystops = g.daystops
                dayrec = g.dayrec
            }
            daystops.push( {...stop, hasArrival, hasDeparture } )
            group.set( day, {daystops, dayrec}  )
            return { group, first}
        }, { 
            group: new Map,
            first: null,
        } )
        let ret = Array.from( group.values() )
        return ret
    }

    const timetable_inf = computed( () => {
        return timetable_inf_func( _get( dataInf, 'timetable' ) || [] )
    })


    const discountob = {
        list: discounts,
        text: discount ? discount : '' ,
        useList: isVdh(dp_id),
    }

    const cruise_link_anchor = anchor => {
        let query = {
            cruiseIdFull,
            anchor,
        }
        const ret = {
            name: 'Cruise',
            query,
        }
        return ret
    }



    return {
        beautifulName, route, min_price,

        photoMain, headPhotos, // is src

        freeCabins, cruiseIdString, cruiseId, cruiseIdFull, checkedH,
        shipId, shipName, shipStar, shipCompany, shipServices,
        dateStartOb, dateEndOb, is_cruise_time_published,
        days, nights, 
        cruise_link, ship_link, cruise_tt_link, cruise_link_anchor,
        isKlk, 

        routeFull, photos,
        included, excluded, description, restaurants, 
        discountob,

        timetable_inf,

        shipHead,
        dates,
    }
}
